import React from 'react';
import {
 Key
} from 'lucide-react';
import PlaceholderPage from '../components/PlaceholderPage';

const ApiKeysPage: React.FC = () => {
    return (
        <PlaceholderPage
            title="API Keys"
            icon={Key}
            description="Generate and manage API keys for external integrations."
        />
    );
};

export default ApiKeysPage;
